<template>
  <el-row class="orderprocessing_framework">
    <el-col style="display: none">
      <audio ref="audioNewOrder" controls muted preload="auto"
      >
        <source :src="newOrderPath" type="audio/mp3">
      </audio>
      <audio ref="audioNewApplication" controls muted preload="auto"
      >
        <source :src="newApplicationPath" type="audio/mp3">
      </audio>
    </el-col>
    <el-col :span="24">
      <el-tabs v-model="activeTabPanName">
        <el-tab-pane name="neworder">
          <div slot="label" class="tab_title">
            <span v-if="newOrderCount==0">新订单</span>
            <el-badge v-else :value="newOrderCount" class="title_item" :max="99">
              <span class="title_text">新订单</span>
            </el-badge>
          </div>
          <new-order v-if="isNewOrder" ref="newOrder" @autoRefresh="getAutoRefreshFlag"></new-order>
        </el-tab-pane>
        <el-tab-pane name="pendingdelivery">
          <div slot="label" class="tab_title">
            <span v-if="deliveryCount==0">待出库</span>
            <el-badge v-else :value="deliveryCount" class="title_item" :max="99">
              <span class="title_text">待出库</span>
            </el-badge>
          </div>
          <pending-delivery v-if="isPendingDelivery"></pending-delivery>
        </el-tab-pane>
        <el-tab-pane name="pendingreceipt">
          <div slot="label" class="tab_title">
            <span v-if="receiptCount==0">待收货</span>
            <el-badge v-else :value="receiptCount" class="title_item" :max="99">
              <span class="title_text">待收货</span>
            </el-badge>
          </div>
          <pending-receipt v-if="isPendingReceipt"></pending-receipt>
        </el-tab-pane>
        <el-tab-pane name="pendingrefund">
          <div slot="label" class="tab_title">
            <span v-if="refundCount==0">待退款</span>
            <el-badge v-else :value="refundCount" class="title_item" :max="99">
              <span class="title_text">待退款</span>
            </el-badge>
          </div>
          <pending-refund v-if="isPendingRefund" ref="pendingRefund"></pending-refund>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
</template>

<script>
import NewOrder from "./OrderProcessing/NewOrder.vue"
import PendingDelivery from "./OrderProcessing/PendingDelivery.vue"
import PendingReceipt from "./OrderProcessing/PendingReceipt.vue"
import PendingRefund from "./OrderProcessing/PendingRefund.vue"
import DataUntils from "@/utils/data.js";
import Stomp from "stompjs";
import GLOBAL from "@/utils/global.js";

export default {
  name: "OrderProcessing",
  components: {
    NewOrder,
    PendingDelivery,
    PendingReceipt,
    PendingRefund,
  },
  data() {
    return {
      //音源路径
      // newOrderPath: require('/media/新的订单请查收.mp3'),
      // newApplicationPath: require('/media/新的申请消息请处理.mp3'),
      newOrderPath: 'https://zdshop.mdline.cn:9961/media/%D0%C2%B5%C4%B6%A9%B5%A5%C7%EB%B2%E9%CA%D5.4b395526.mp3',
      newApplicationPath: 'https://zdshop.mdline.cn:9961/media/%D0%C2%B5%C4%C9%EA%C7%EB%CF%FB%CF%A2%C7%EB%B4%A6%C0%ED.aa748826.mp3',
      //客户端
      newOrderClient: Stomp.client('wss://zdshop.mdline.cn/wss'),
      newOrderWS: new WebSocket('wss://zdshop.mdline.cn/wss'),
      //交换机订阅名称
      newOrderExchange: '/exchange/remind.direct/remind',
      //tab相关
      activeTabPanName: "neworder",
      isNewOrder: true,
      isPendingDelivery: false,
      isPendingReceipt: false,
      isPendingRefund: false,
      newOrderCount: 0,
      deliveryCount: 0,
      receiptCount: 0,
      refundCount: 0,
      autoRefresh: GLOBAL.autoRefreshFlag,
    };
  },
  watch: {
    activeTabPanName: {
      handler: function (val) {
        this.isNewOrder = false;
        this.isPendingDelivery = false;
        this.isPendingReceipt = false;
        this.isPendingRefund = false;
        switch (val) {
          case "neworder":
            this.isNewOrder = true;
            break;
          case "pendingdelivery":
            this.isPendingDelivery = true;
            break;
          case "pendingreceipt":
            this.isPendingReceipt = true;
            break;
          case "pendingrefund":
            this.isPendingRefund = true;
            break;
          default:
            break;
        }
        //拉取小红点里面的数据
        this.getTabsData();
      }
    },
  },
  created() {
    this.getTabsData();
    this.connect();
  },
  mounted() {
    //开销小的做法是在子组件中操作之后，再更新小红点的数据，而不是一直发请求
    this.timer = setInterval(() => {
      this.getTabsData();
    }, 1000 * 60)
    //断开后，1s之后重连
    this.newOrderWS.onclose = (e) => {
      console.log('<<<断开重连>>>');
      console.log('e>>', e)
      // let that = this;
      setTimeout(() => {
        console.log("刷新组件");
        // that.$forceUpdate();
        //   this.$store.dispatch("MessageQueue/handleClearMQ", {queueName: 'remind'})
        //       .then((res) => {
        //         console.log(res);
        //
        //       })
        //       .catch((res) => {
        //         console.log(res);
        //       })
        // }
        location.reload()
      }, 1000);

    };
  },
  destroyed() {
    clearInterval(this.timer);
    this.close();
  },
  methods: {
    connect() {
      //创建连接,放入连接成功和失败回调函数
      let headers = {
        "login": GLOBAL.ACCOUNT,
        "passcode": GLOBAL.PASSWORD,
        //虚拟主机，默认“/”
        "host": GLOBAL.HOST,
      };
      this.newOrderClient.connect(headers, this.onConnected, this.onFailed);
    },
    //webSocket连接成功后回调函数
    onConnected(frame) {
      console.log("Connected: " + frame);
      //绑定交换机exchange_pushmsg是交换机的名字rk_pushmsg是绑定的路由key
      // var exchange = "/exchange/testQueue.direct/magic";
      //创建随机队列用上面的路由key绑定交换机,放入收到消息后的回调函数和失败的回调函数
      this.newOrderClient.subscribe(this.newOrderExchange,
          this.responseCallbackOfNewOrder,
          this.onFailed
      );
      console.log('<<<连接成功>>>');
      // console.log(frame)
    },
    onFailed(frame) {
      console.log("<<<连接失败>>>\nFailed: " + frame);
      console.dir(frame);
      console.log("刷新组件");
      // this.$forceUpdate();
      setTimeout(() => {
        location.reload();
      }, 5000);
    },
    responseCallbackOfNewOrder(frame) {
      // this.client.ack();
      console.log("得到的消息 msg=>" + frame.body);
      // console.log(frame);
      // console.log(this.autoRefresh,'///////');
      if (frame.body === 'new') {
        // 自动拉取
        if (this.activeTabPanName === 'neworder' && this.autoRefresh === true) {
          this.$refs.newOrder.getOrderList();
        } else if (this.activeTabPanName === 'neworder' && this.autoRefresh === false) {
          //显示“有新订单，请刷新”的按钮
          this.$refs.newOrder.refreshBtn = true;
        }
        this.getNewOrderCount();
        this.$notify({
          title: '提示',
          message: '您有新的订单，请注意查收！',
          duration: 10000
        });
        let music = new Audio();
        music = 'https://zdshop.mdline.cn:9961/media/%D0%C2%B5%C4%B6%A9%B5%A5%C7%EB%B2%E9%CA%D5.4b395526.mp3';
        this.$refs.audioNewOrder.src = music;
        this.$refs.audioNewOrder.play();
        this.$store.dispatch("MessageQueue/handleReceive", {queueName: 'remind'})
            .then((res) => {
              console.log(res);
            })
            .catch((res) => {
              console.log(res);
            })
      } else if (frame.body === 'refund') {
        if (this.activeTabPanName === 'pendingrefund') {
          this.$refs.pendingRefund.getOrderList();
        }
        this.$notify({
          title: '提示',
          message: '您有新的申请消息，请处理！',
          duration: 10000
        });
        let music = new Audio();
        music = 'https://zdshop.mdline.cn:9961/media/%D0%C2%B5%C4%C9%EA%C7%EB%CF%FB%CF%A2%C7%EB%B4%A6%C0%ED.aa748826.mp3';
        this.$refs.audioNewOrder.src = music;
        this.$refs.audioNewOrder.play();
        this.$store.dispatch("MessageQueue/handleReceive", {queueName: 'remind'})
            .then((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
            })
            .catch((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
            })
      } else if (frame.body === 'cancelNew') {
        //管理端没确认，用户付款之后自己取消订单
        if (this.activeTabPanName === 'neworder') {
          this.$refs.newOrder.getOrderList();
        }
      }
    },
    //退出
    close() {
      this.newOrderClient.disconnect(() => {
        console.log('<<<已退出消息队列订阅>>>');
      });
    },
    //自动刷新按钮
    getAutoRefreshFlag(flag) {
      this.autoRefresh = flag;
    },
    // //“新订单”界面“确认接单”的数目，“待出库”增加
    // getNewDeliveryCnt(cnt){
    //   this.deliveryCount += cnt;
    // },
    // //“待出库”界面“确认出库”的数目，“待收货”增加
    // getNewReceiptCnt(cnt){
    //   this.receiptCount += cnt;
    // },
    // //获取新订单数目
    // getNewOrderCount(val) {
    //   this.newOrderCount = val;
    // },
    // //获取待出库数目
    // getDeliveryCount(val) {
    //   this.deliveryCount = val;
    // },
    // //获取待收货数目
    // getReceiptCount(val) {
    //   this.receiptCount = val;
    // },
    // //获取待退款数目
    // getRefundCount(val) {
    //   this.refundCount = val;
    // },

    //  tab部分单独请求小红点中的数据
    getTabsData() {
      this.getNewOrderCount();
      this.getDeliveryCount();
      this.getReceiptCount();
      this.getRefundCount();
      // console.log('tab')
    },
    //  新订单数量
    getNewOrderCount() {
      DataUntils.getOrderListByStatus({
        status: '已付款'
      })
          .then((res) => {
            this.newOrderCount = res.pageData.totalSize;
          })
          .catch(() => {
            location.reload();
          })
    },
    //  待出库数量
    getDeliveryCount() {
      DataUntils.getOrderListByStatus({
        status: '待出库'
      })
          .then((res) => {
            this.deliveryCount = res.pageData.totalSize;
          })
    },
    //  待收货数量
    getReceiptCount() {
      DataUntils.getOrderListByStatus({
        status: '待收货'
      })
          .then((res) => {
            this.receiptCount = res.pageData.totalSize;
          })
    },
    //  待退款数量
    getRefundCount() {
      DataUntils.getOrderListByStatus({
        status: '待退款'
      })
          .then((res) => {
            this.refundCount = res.pageData.totalSize;
          })
    },
  },
};
</script>

<style>
.orderprocessing_framework {
  padding-left: 20px;
}

.tab_title {
  margin: 0 20px;
  font-size: 16px;
}

.el-tabs__nav-scroll {
  padding-top: 15px;
  padding-left: 20px;
  height: 40px;
}

.title_item {
  padding-top: 0;
}

.el-badge__content.is-fixed {
  top: 5px !important;
  right: 5px !important;
}
</style>
